export const WELCOME_MESSAGE =
  'Hello! I’m your Melody and always ready to help. Just type in your question about this PDF, and I’ll do my best to answer it. Don’t worry if it’s complicated—I’m here to make things easier. Following the guidelines of trustworthy AI, I would like to tell you that I am not a natural person, but an artificially created intelligence. Nevertheless, I would love to assist you. Any questions?';

export const MELODY_AVATAR = '/img/melody__.png';
